module.exports = __webpack_public_path__ + "b3c5286d6ef503c103d9fb934d88f0fd.MP3";